module.exports = __webpack_public_path__ + "static/anils-ghost-3c695c71762b16c819417c4c8ade9ae5.jpg";